import { render, staticRenderFns } from "./MatterPreview.vue?vue&type=template&id=6014729e&scoped=true"
import script from "./MatterPreview.vue?vue&type=script&lang=js"
export * from "./MatterPreview.vue?vue&type=script&lang=js"
import style0 from "./MatterPreview.vue?vue&type=style&index=0&id=6014729e&prod&lang=scss&scoped=true"
import style1 from "./MatterPreview.vue?vue&type=style&index=1&id=6014729e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014729e",
  null
  
)

export default component.exports